import { Grid } from '@mui/material';
import ExchangeRates from '../exchangerates/ExchangeRates';
import ExchangeRateCalculator from '../exchangerates/ExchangeRateCalculator';

export function Dashboard() {
    return (
        <Grid container gap={8}>
            <Grid item>
                <ExchangeRates />
            </Grid>
            <Grid item>
                <ExchangeRateCalculator />
            </Grid>
        </Grid>
    );
}
